import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataService, StorageService } from 'src/app/_services';

@Component({
  selector: 'app-sideitem',
  templateUrl: './sideitem.component.html',
  styleUrls: ['./sideitem.component.css']
})
export class SideitemComponent implements OnInit {

  @Input('request') request: any;
@Input('active') active : boolean;
@Input('loading') loading = false;
currentUser: any;
@Output() loadSheetData = new EventEmitter();

  constructor(
    private dataService: DataService,
    private storageService: StorageService
  ) { 

    this.currentUser = this.storageService.read<any>('currentUser');
    this.dataService.onRequestLoadingEndFromBackend.subscribe(res => {
      this.loading = false;
    });
  }

  ngOnInit() {
  }

  sendSheetData(request) {
    this.loadSheetData.emit(request);
  }

}
